export const reportRepositoryAddComponent = {
	template: `
                <report-repository-main 
                        details = "$ctrl.details"
                        page-title='{{$ctrl.pageTitle}}' 
                        is-short-details = "{{$ctrl.isShortDetails}}"
			disable-buttons='$ctrl.disableButtons'
                        on-submit='$ctrl.onSubmit({$event: $event})'
                        on-cancel="$ctrl.onCancel({$event: $event})"
                        service-area-list = "$ctrl.serviceAreaList"
			program-years = "$ctrl.programYears">
                </report-repository-main>`,

	bindings: {
		details: '<',
		pageTitle: "@",
		programYears: '<',
		serviceAreaList: '<',
		isShortDetails: '@',
		disableButtons: '<',
		onSubmit: '&',
		onCancel: '&'
	},
	//controller for ProgressReportsAddComponent
	controller: class ReportRepositoryAddComponent {
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/report-repository/report-repository-add/report-repository-add.component.js